import { useClientConfig } from "campaign-builder/context/ClientConfigContext";
import { resolveMinLeadTimeBusinessDays } from "../state/leadTime";

/**
 * The H2H/D2D minimum lead time (business days), sourced from the country's OADS
 * settings (`countryDefaultSettings.defaultCampaignLimits`). Consumed by the launch
 * date picker (F2), the per-area distribution calendar (F6), and the invalid-date
 * warning (F9). Falls back to a safe default until country settings have loaded.
 */
export const useMinLeadTimeBusinessDays = (): number => {
  const { country } = useClientConfig();
  return resolveMinLeadTimeBusinessDays(country?.countryDefaultSettings?.defaultCampaignLimits);
};
